import { useMemo } from "react";
import { useSelector } from "react-redux";

import { useTableSelectionCondition } from "./useTableSelectionCondition";
import { useGeometrySelectionConditions } from "../geometrySelection/useGeometrySelectionConditions";
import { getTableFilterConditions } from "../../ducks/table/selectors";

import { LayerInfo } from "../../interfaces/resourceInfo";
import { FilterConditionOperation } from "../../components/LayerFilter/types";

export const useTempTableCondition = (layer: LayerInfo) => {
  const tableSelectionCondition = useTableSelectionCondition(layer);
  const geometrySelectionConditions = useGeometrySelectionConditions();
  const tableFilterConditions = useSelector(getTableFilterConditions);

  return useMemo(
    () =>
      [geometrySelectionConditions?.[layer.name], tableFilterConditions?.[layer.name], tableSelectionCondition]
        .filter(Boolean)
        .join(` ${FilterConditionOperation.AND} `),
    [layer.name, geometrySelectionConditions, tableFilterConditions, tableSelectionCondition],
  );
};
